import { Input } from "@chakra-ui/input";
import type { FormInputProps } from "../../interfaces";
import FormInputWraper from "../../Components/FormInputWrapper";
import { INPUT_SIZE, INPUT_VARIANT } from "../../RegisterPage";
import { useTranslations } from "next-intl";

const FiscalNumberIdInput = ({ FormController, disabled, color }: FormInputProps) => {
  const t = useTranslations("pages.register");
  return (
    <FormInputWraper
      isRequired
      field_name="fiscal_id_number"
      key="fiscal_id_number_input"
      color={color}
      label={t("fiscalNumber")}
      FormController={FormController}
    >
      <Input
        id="fiscal_id_number"
        key="fiscal_id_number"
        variant={INPUT_VARIANT}
        size={INPUT_SIZE}
        {...FormController.register("fiscal_id_number", {
          required: t("fiscalNumberReqMessage"),
        })}
        isDisabled={disabled}
      />
    </FormInputWraper>
  );
};

export default FiscalNumberIdInput;
